import React from 'react';
import {
  InformationPageContentWrapper,
  InformationPageTitleText,
  InformationPagePageMainText,
  InformationPageButtonsContainer,
  InformationPageContainer,
} from './styles/informationPages.styles';
import { useTypedTranslate } from '../../translations/useTypedTranslate';
import { ErrorLicensePlatesIcon } from './styles/InformationPageIcons.styles';
import ReactMarkdown from 'react-markdown';
import { MakeCallButton } from '../../components/MakeCallButton/MakeCallButton';
import { TryAgainButton } from '../../components/TryAgainButton/TryAgainButton';

export const PlateNumberErrorPage: React.FC = () => {
  const { t } = useTypedTranslate();

  return (
    <InformationPageContainer>
      <InformationPageContentWrapper>
        <ErrorLicensePlatesIcon />
        <InformationPageContentWrapper style={{ gap: 0 }}>
          <InformationPageTitleText>{t('CAN_NOT_READ_PLATE_NUMBER_FROM_IMAGE')}</InformationPageTitleText>
          <InformationPagePageMainText>
            <ReactMarkdown>{t('TRY_AGAIN_TO_LOAD_PHOTO_OR_MAKE_CALL')}</ReactMarkdown>
          </InformationPagePageMainText>
        </InformationPageContentWrapper>
        <InformationPageButtonsContainer>
          <MakeCallButton />
          <TryAgainButton />
        </InformationPageButtonsContainer>
      </InformationPageContentWrapper>
    </InformationPageContainer>
  );
};
